export interface IProduct {
  id: string;
  name: string;
  description: string;
  barcode: string;
  images: IProductImage[];
  countries: IProductCountry[];
}

export interface IProductCreateRequest {
  barcode: string;
  active: boolean;
  entityId: string;
  productMeasurement: string;
  reseller: boolean;
  allowOnline: boolean;
  parentId: string;
  sku: string;
  brandId: string;
  categoryIds: ICategory[];
  taxDefinitionIds: IProductTaxDefinition[];
  productImageIds: IProductImage[];
  productLocaleMetadata: ILocalMetadata[];
}

export interface IProductCountryRequest {
  entityId: string;
  productId: string;
  countryId: string;
  productCode: string;
  sku: string;
}

export interface IDuplicateProductRequest {
  duplicateProductId: string;
  entityId: string;
  imagesToCopy: string[];
  isVariant: boolean;
}

export interface IProductCreateResponse {
  id: string;
  name: string;
  description: string;
  barcode: string;
  price: number;
  fastestMovingOrLowestSupplier: any;
  images: IProductImage[];
  productMeasurement: string;
  category: any;
  properties: any;
  countries: IProductCountry[];
}

export interface ILocalMetadata {
  id?: string;
  key: string;
  value: string;
  locale: string;
  showPublic: boolean;
}

export interface IProductTaxDefinition {
  rate: number;
  country: ICountry;
}

interface ICountry {
  id: string;
  name: string;
}

interface ICategory {
  id: string;
  name: string;
}

interface IProductImage {
  id?: string;
  url: string;
  sizes: IProductImageSize[];
}

export interface IProductImageSize {
  url: string;
  height: number;
}

export interface IProductCountry {
  id: string;
  name: string;
  currencyName: string;
  isoCurrencySymbol: string;
  taxRate: number;
  minimumPrice: any;
  locations: IProductCountryLocation[];
}

export interface IProductCountryLocation {
  id: string;
  name: string;
  isCurrentlyBeingSold: boolean;
  price: number;
}
